import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { IAllowedCountriesResponse } from 'src/interfaces/responses';
import { QueryKey } from 'src/constants/queryKeys';
import { AxiosResponse, AxiosError } from 'axios';

import { getAllowedCountriesForPayement } from '../banking';

export const useAllowedCountriesForPaymentQuery = (): UseQueryResult<AxiosResponse<IAllowedCountriesResponse, AxiosError> | undefined> =>
  useQuery([QueryKey.QUERY_ALLOWED_COUNTRIES_FOR_PAYMENT], () => getAllowedCountriesForPayement());
